import React from "react";

export default function PrintStyles() {
  return (
    <style
      dangerouslySetInnerHTML={{
        __html: `
@media print {
  * { 
    -webkit-print-color-adjust: exact; 
    print-color-adjust: exact;
    box-sizing: border-box;
  }
  
  /* Layout geral para impressão */
  body { 
    font-family: 'Inter', system-ui, -apple-system, sans-serif !important;
    line-height: 1.4 !important;
    background: white !important;
    color: #000 !important;
  }
  
  /* Evita cortar cards/tabelas ao meio */
  .print-no-break { 
    break-inside: avoid !important; 
    page-break-inside: avoid !important;
    display: block !important;
  }
  
  /* Remove efeitos visuais que causam problemas na captura */
  .print-flat { 
    box-shadow: none !important; 
    filter: none !important; 
    transform: none !important;
    backdrop-filter: none !important;
    border-radius: 6px !important;
  }
  
  /* Expande listas/tabelas que teriam scroll na UI */
  .print-expand { 
    max-height: none !important; 
    overflow: visible !important;
    height: auto !important;
  }
  
  /* Alinhamento correto para badges/pills */
  .print-badge { 
    display: inline-flex !important;
    align-items: center !important;
    justify-content: center !important;
    vertical-align: middle !important;
    line-height: 1 !important;
    white-space: nowrap !important;
    text-align: center !important;
    padding: 2px 8px !important;
    border-radius: 4px !important;
    font-size: 11px !important;
    font-weight: 500 !important;
  }
  
  /* Cabeçalhos de tabela em cada página */
  thead { display: table-header-group !important; }
  tfoot { display: table-footer-group !important; }
  
  /* Evita quebras ruins em linhas de tabela */
  tr, .row-avoid-break { 
    break-inside: avoid !important; 
    page-break-inside: avoid !important;
  }
  
  /* Títulos de seções sempre juntos com conteúdo */
  .print-section-title {
    break-after: avoid !important;
    page-break-after: avoid !important;
    margin-bottom: 8px !important;
  }
  
  /* Cards de seção bem estruturados */
  .print-card {
    border: 1px solid #e5e5e5 !important;
    border-radius: 6px !important;
    margin-bottom: 16px !important;
    background: white !important;
  }
  
  /* Quebras de página controladas */
  .html2pdf__page-break { 
    page-break-before: always !important;
    break-before: page !important;
    height: 0 !important;
    margin: 0 !important;
    padding: 0 !important;
    border: none !important;
  }
  
  /* Tabelas responsivas para impressão */
  .print-table {
    width: 100% !important;
    border-collapse: collapse !important;
    font-size: 10px !important;
  }
  
  .print-table th,
  .print-table td {
    border: 1px solid #ddd !important;
    padding: 4px 6px !important;
    text-align: left !important;
    vertical-align: top !important;
  }
  
  .print-table th {
    background-color: #f8f9fa !important;
    font-weight: 600 !important;
  }
  
  /* Grid responsivo para impressão */
  .print-grid {
    display: grid !important;
    gap: 8px !important;
    grid-template-columns: repeat(auto-fit, minmax(100px, 1fr)) !important;
  }
  
  /* Comentários e anexos expandidos */
  .print-comments-full,
  .print-attachments-full {
    max-height: none !important;
    overflow: visible !important;
  }
  
  /* Imagens otimizadas */
  .print-image {
    max-width: 100% !important;
    height: auto !important;
    break-inside: avoid !important;
  }
  
  /* Texto com quebra suave */
  .print-text {
    word-wrap: break-word !important;
    overflow-wrap: break-word !important;
    hyphens: auto !important;
  }
}
        `,
      }}
    />
  );
}